<template>
	<div>
		<b-row class="container m-0">
			<b-col v-if="!hideBreadcrumbs" cols="12" class="p-0">
				<div class="breadcumbs">
					<span v-for="(breadcrumb, index) in breadcrumbs" :key="index" class="breadcrumb">
						<span class="breadcrumb-name" @click="openFolder(breadcrumb.path)">{{breadcrumb.name}}</span>
					</span>
				</div>
			</b-col>
			<b-col v-if="!hideActions" cols="12" class="p-0">
				<div class="actions mb-3">
					<b-button variant="success" @click="$refs.fileUpload.click()">Upload Files</b-button>
					<input type="file" ref="fileUpload" class="d-none" @input="onFileInput" multiple />
				</div>
			</b-col>
			<b-col cols="12" class="p-0">
				<div class="iconContainer" v-for="(document, index) in documents" :key="index" @click="onIconClick(document)">
					<icon v-if="document.size == 0" name="folder" scale="3" class="folder" />
					<icon v-else name="regular/file-alt" scale="3" class="document" />
					<div class="name">{{document.name}}</div>
					<b-dropdown v-if="!hideContextMenu" size="lg" variant="link" toggle-class="text-decoration-none" class="contextMenu" no-caret>
						<template slot="button-content">
							<icon name="ellipsis-v" scale="1" />
						</template>

						<b-dropdown-item href="#" @click="deleteFile($event, document.key)">Delete</b-dropdown-item>
					</b-dropdown>
				</div>
			</b-col>
		</b-row>

		<DocumentViewer :visible="isViewingDocument" :title="title" :filePath="filePath" @hide="closeViewingDocument" />
	</div>
</template>

<script>
	import DocumentViewer from "./DocumentViewer"

	export default {
		name: 'Documents',
		components: {
			DocumentViewer
		},
		props: {
			path: String,
			showAll: Boolean,
			hideBreadcrumbs: Boolean,
			hideActions: Boolean,
			hideContextMenu: Boolean,
		},
		data: function () {
			return {
				workingPath: false,
				viewingDocument: false,
				filePath: "",
				title: ""
			}
		},
		mounted: function () {
			if (this.path == null || this.path == "")
				return

			this.$store.dispatch("Documents/getDocuments", this.path)
		},
		watch: {
			path: {
				immediate: true,
				deep: true,
				handler(newValue, oldValue) {
					this.workingPath = newValue
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			documents: function () {
				return this.$store.state.Documents.documents
					.slice()
					.filter(x => {
						if (this.showAll)
							return true

						if (x.size == 0 && this.workingPath == "branch/" && !this.isBranchFolder(x.key))
							return false

						if (this.isEmployee && x.size > 0 && x.user != "True")
							return false

						if (this.isClient && x.size > 0 && x.client != "True")
							return false

						return true
					})
					.sort(this.$store.getters["Helper/compareValues"]("size", "asc"))
					.map(x => {
						var name = this.getDocumentName(x)

						return {
							size: x.size,
							name: name,
							key: x.key
						}
					})
			},
			breadcrumbs: function () {
				var breadcrumbs = []
				var pathParts = this.workingPath.split("/").filter(x => x != "")
				
				for (var i = 0; i < pathParts.length; i++) {
					var pathPart = pathParts[i]
					var name = pathPart
					var path = `${breadcrumbs.length < 1 ? "" : breadcrumbs[breadcrumbs.length - 1].path}${pathPart}/`

					name = name == "branch" ? "Home" : name

					if (i == 1 && this.isBranchSubFolder(this.workingPath))
						name = this.profile.branches.filter(x => x[0] == pathPart)[0][1]

					breadcrumbs.push({ name: name, path: path })
				}

				return breadcrumbs
			},
			isViewingDocument: function () {
				return this.viewingDocument
			},
			isEmployee: function () {
				return this.profile.accounttype == 2
			},
			isClient: function () {
				return this.profile.accounttype == 3
			}
		},
		methods: {
			isBranchFolder: function (key) {
				return this.profile.branches.some(x => `branch/${x[0]}/` == key)
			},
			isBranchSubFolder: function (key) {
				return this.profile.branches.some(x => key.indexOf(`branch/${x[0]}/`) > -1)
			},
			isClientFolder: function (key) {
				return key.indexOf(`client/${this.profile.userid}/`) > -1
			},
			getDocumentName: function (document) {
				var keyParts = document.key.split("/")
				var name = keyParts[keyParts.length - 1]

				if (document.size == 0) {
					if (this.isBranchFolder(document.key)) {
						var branch = this.profile.branches.filter(x => x[0] == keyParts[keyParts.length - 2])[0]
						name = branch[1]
					}
					else {
						name = keyParts[keyParts.length - 2]
					}
				}

				return name
			},
			onIconClick: function (document) {
				if (document.size == 0) {
					this.openFolder(document.key)
				}
				else {
					this.openViewingDocument(document.key)
				}
			},
			openFolder: function (path) {
				this.workingPath = path

				this.$store.dispatch("Documents/getDocuments", path)
			},
			openViewingDocument: function (filePath) {
				this.viewingDocument = true
				this.filePath = filePath

				var filePathParts = filePath.split("/")

				this.title = filePathParts[filePathParts.length - 1]
			},
			closeViewingDocument: function () {
				this.viewingDocument = false
			},
			onFileInput: function () {
				var files = []

				for (var i = 0; i < this.$refs.fileUpload.files.length; i++) {
					var file = this.$refs.fileUpload.files[i]

					files.push(file)
				}

				this.$emit("input", files)
			},
			deleteFile: function (event, key) {
				event.stopPropagation()

				this.$store.dispatch(
					"Documents/deleteFiles",
					[key])
					.then(() => {
						this.$emit("deleted")
					})
			}
		}
	}
</script>
<style>
	.container .iconContainer .contextMenu .dropdown-toggle {
		padding: 0 !important;
		line-height: 0;
	}

		.container .iconContainer .contextMenu .dropdown-toggle svg {
			top: 0;
			right: 0;
			fill: #7F92B8;
		}
</style>
<style scoped>
	.container {
		min-height: 5rem;
	}

		.container svg {
			top : 0;
			transform: translate(0, 0%) !important;
			position: inherit !important;
			display: initial !important;
		}

		.container .breadcrumb {
			display: inline-block;
			padding: 0;
			background-color: unset;
			cursor: pointer;
			font-weight: bold;
			user-select: none;
		}

			.container .breadcrumb:not(:last-child)::after {
				content: "/ ";
				margin: 0 5px;
				cursor: default;
				color: #b5c1da;
				font-size: 15px;
			}

		.container .actions {
			display: inline-block;
			padding: 0;
			background-color: unset;
			cursor: pointer;
			font-weight: bold;
			user-select: none;
		}

		.container .iconContainer {
			float: left;
			position: relative;
			width: 100px;
			height: 105px;
			margin-right: 20px;
			margin-bottom: 20px;
			text-align: center;
			font-size: 12px;
			cursor: pointer;
			user-select: none;
		}

			.container .iconContainer .folder {
				color: #E94A79;
				fill: #E94A79;
			}

			.container .iconContainer .document {
				color: #b5c1da;
				fill: #b5c1da;
			}

			.container .iconContainer .name {
				margin-top: 6px;
				word-break: break-all;
				font-weight: bold;
			}

			.container .iconContainer .contextMenu {
				position: absolute;
				top: 0;
				right: 0;
				padding: 0 !important;
			}
</style>